import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { generateAgentOtp } from "../services/agentManagement.service";

// Define initial state
const initialState = {
    data: {
        phone: "",
        otpRef: "",
        otp: "",
        phoneVerify: false,
        first_name: "",
        last_name: "",
        shop_name: "",
        username: "",
        email: "",
        password: "",
        physicalAddress: "",
        typeOfBusiness: "",
        mfsNumbers: [],
        nidOrTradeLicense: "",
        nid: "",
        tradeLicence: "",
        agentAdmin: "",
        agentHunter: "",
    },
    step: 0,
    loading: false,
    error: null,
};

// Define the slice
const agentUserReg = createSlice({
    name: "agentUserReg",
    initialState,
    reducers: {
        clearAgentReducer: (state) => {
            state.data = { ...initialState.data };
            state.step = 0;
            state.loading = false;
            state.error = null;
        },
        changeStep: (state, action) => {
            state.step = action.payload;
        },
        setOtpRef: (state, action) => {
            state.data.otpRef = action.payload;
        },
        setPhone: (state, action) => {
            state.data.phone = action.payload;
        },
        setOtp: (state, action) => {
            state.data.otp = action.payload;
        },

        phoneVerified: (state) => {
            state.data.phoneVerify = true;
        },

        phoneAlreadyVerified: (state) => {
            state.data.phoneVerify = true;
            state.step = 2;
        },
        addDetailInfoAction: (state, action) => {
            state.data.first_name = action.payload.first_name;
            state.data.last_name = action.payload.last_name;
            state.data.username = action.payload.username;
            state.data.email = action.payload.email;
            state.data.password = action.payload.password;
            state.data.shop_name = action.payload.shop_name;
            state.data.physicalAddress = action.payload.physicalAddress;
            state.data.typeOfBusiness = action.payload.typeOfBusiness;
            state.data.mfsNumbers = action.payload.mfsNumbers;
            state.data.nid = action.payload.nid;
            state.data.tradeLicence = action.payload.tradeLicence;
            state.data.nidOrTradeLicense = action.payload.nidOrTradeLicense;
        },
        setAgentParents: (state, action) => {
            state.data.agentAdmin = action.payload.agentAdmin;
            state.data.agentHunter = action.payload.agentHunter;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateOtpThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateOtpThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.data.otpRef = action.payload?.data?.referenceId;
            })
            .addCase(generateOtpThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message;
            });
    },
});

export const generateOtpThunk = createAsyncThunk(
    "agentUserReg/generateOtp",
    async (_, { getState }) => {
        const { data } = getState().agentUserReg;
        if (data.otpRef != null && data.otpRef.length > 0) {
            return data;
        }

        try {
            const response = await generateAgentOtp({
                purpose: "login",
                recipients: [
                    {
                        channel: "sms",
                        msisdn: `+880${String(data.phone).slice(-10)}`,
                    },
                ],
            });
            return response.data;
        } catch (error) {
            return error;
        }
    }
);

// Export the actions and reducer
export const {
    clearAgentReducer,
    setOtpRef,
    setPhone,
    setOtp,
    changeStep,
    phoneVerified,
    phoneAlreadyVerified,
    addDetailInfoAction,
    setAgentParents,
} = agentUserReg.actions;
export default agentUserReg.reducer;
